import React from 'react';
import T from 'prop-types';

import useToggle from '../../hooks/useToggle';

import { AntCard, AntCardHead, AntCardHeadWrapper, AntCardHeadTitle, AntCardBody, DownIcon, MinusIcon } from './style';

const CollapsibleCard = ({ children, isCollapsed, title }) => {
  const [collapsed, toggleCollapse] = useToggle(isCollapsed);
  const icon = collapsed ? <DownIcon /> : <MinusIcon />;

  return (
    <AntCard>
      <AntCardHead onClick={() => toggleCollapse()}>
        <AntCardHeadWrapper>
          <AntCardHeadTitle>{title}</AntCardHeadTitle>
          {icon}
        </AntCardHeadWrapper>
      </AntCardHead>
      <AntCardBody>{!collapsed && children}</AntCardBody>
    </AntCard>
  );
};

CollapsibleCard.defaultProps = {
  children: null,
  isCollapsed: true,
};

CollapsibleCard.propTypes = {
  title: T.string.isRequired,

  children: T.node,
  isCollapsed: T.bool,
};

export default CollapsibleCard;
